import { useAtom } from 'jotai';
import oneTrustConsentAtom from '../OneTrustAtom/oneTrustConsentAtom';
import { useEffect } from 'react';
import isKustomerChatEnabled from '../../app/helpers/isKustomerChatEnabled';
import { isClient, setElementOpacity } from '../../app/globals';
import loadKustomerScript from '../../app/helpers/loadKustomerScript';
import getEnvValue from '@joybird/joystagram-components/dist/esm/getEnvValue';
import { useCallback } from 'react';
import useOneTrustAtomHandler from '../OneTrustAtom';
import shouldDisablePopups from '../../app/helpers/shouldDisablePopups';
import useUserData from '@joybird/joystagram-components/dist/esm/useUserData';

const unloadKustomerChat = () => {
  if (isClient() && window?.Kustomer) {
    window.Kustomer.stop();
  }
};

const isAmazonBot = () => {
  if (isClient()) {
    const userAgent = window?.navigator?.userAgent || '';
    // The amazon bot can have different names. amazonbot, amazonproductbot, amazonbrowserbot, etc.
    // The conditionals below should capture all versions of the user agent
    return userAgent?.includes('amazon') && userAgent?.includes('bot');
  }
  return false;
};

const ChatWidgets = () => {
  const [hasConsentOneTrust] = useAtom(oneTrustConsentAtom);
  useOneTrustAtomHandler();
  const { isTradeUser } = useUserData();

  const initKustomerChat = useCallback(() => {
    if (isClient()) {
      window?.Kustomer.start(
        {
          brandId: getEnvValue('REACT_APP_KUSTOMER_BRANDID'),
        },
        () => {
          setElementOpacity('#kustomer-ui-sdk-iframe', 1);
        }
      );
    }
  }, []);

  const initChatIfRequired = useCallback(() => {
    if (
      isKustomerChatEnabled() &&
      !shouldDisablePopups() &&
      hasConsentOneTrust &&
      !isAmazonBot()
    ) {
      loadKustomerScript();
      window.addEventListener('kustomerLoaded', initKustomerChat);
    }
  }, [initKustomerChat, hasConsentOneTrust]);

  useEffect(() => {
    if (!isTradeUser) {
      initChatIfRequired();
      if (!hasConsentOneTrust) {
        unloadKustomerChat();
      }
    }
    return () => {
      window.removeEventListener('kustomerLoaded', initKustomerChat);
    };
  }, [hasConsentOneTrust, isTradeUser, initChatIfRequired]);

  return null;
};

export default ChatWidgets;
